import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-900">叮咚漫画网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              叮咚漫画网新作首发 / 独家抢先看 / 新番上架速递。第一时间上架新作与独家内容，每日更新新作列表，热门新漫速递，让你永远快人一步。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#subscribe"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line" />
              </a>
              <a
                href="#subscribe"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="哔哩哔哩"
                rel="nofollow"
              >
                <i className="ri-bilibili-line" />
              </a>
              <a
                href="#subscribe"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line" />
              </a>
              <a
                href="#subscribe"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                aria-label="抖音"
                rel="nofollow"
              >
                <i className="ri-music-2-line" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-900">快速导航</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link className="text-foreground-600 hover:text-primary-600" to="/new-releases">新番速递</Link></li>
              <li><Link className="text-foreground-600 hover:text-primary-600" to="/works">作品库</Link></li>
              <li><Link className="text-foreground-600 hover:text-primary-600" to="/faq">常见问题</Link></li>
              <li><Link className="text-foreground-600 hover:text-primary-600" to="/about">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-900">联系交流</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center gap-2 text-foreground-600">
                <i className="ri-mail-line text-primary-500" /> service@dingdongmanga.com
              </li>
              <li className="flex items-center gap-2 text-foreground-600">
                <i className="ri-wechat-line text-primary-500" /> 公众号：叮咚漫画网
              </li>
              <li className="flex items-center gap-2 text-foreground-600">
                <i className="ri-time-line text-primary-500" /> 每日 09:00 - 23:00
              </li>
              <li>
                <Link className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-700" to="/contact">
                  在线留言 <i className="ri-arrow-right-line text-sm" />
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 叮咚漫画网 · 新作首发 / 独家抢先看 / 新番上架速递
          </p>
          <div className="flex items-center gap-5 text-xs text-foreground-500">
            <Link to="/about" className="hover:text-primary-600">网站介绍</Link>
            <Link to="/faq" className="hover:text-primary-600">帮助中心</Link>
            <Link to="/contact" className="hover:text-primary-600">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}